import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Apollo } from 'apollo-angular';

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { CentroService } from 'src/app/services/centro.service';
import { DetalleService } from 'src/app/services/detalle.service';
import { DocDetalleCentroComponent } from 'src/app/components/portal-contratista/centro/doc-detalle-centro/doc-detalle-centro.component';
import { DocumentoService } from 'src/app/services/documento.service';
import { DocumentosComponent } from 'src/app/components/portal-contratista/gestor/formularios/documentos/documentos.component';
import { DocumentosCentroComponent } from 'src/app/components/portal-contratista/centro/formularios/documentos-centro/documentos-centro.component';
import { LoginService } from 'src/app/services/login.service';
import { GestorService } from 'src/app/services/gestor.service';
import { TransportistaService } from 'src/app/services/transportista.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { element } from 'protractor';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';
import { DocumentosAdicCentroComponent } from 'src/app/components/portal-contratista/centro/formularios/documentos-adic-centro/documentos-adic-centro.component';
import { DocAdicDetalleCentroComponent } from 'src/app/components/portal-contratista/centro/doc-adic-detalle-centro/doc-adic-detalle-centro.component';
import { TSError } from 'ts-node';
import { TestBed } from '@angular/core/testing';


@Component({
  selector: 'app-detalle-centro',
  templateUrl: './detalle-centro.component.html',
  styleUrls: ['./detalle-centro.component.scss']
})

export class DetalleCentroComponent implements OnInit {

  disableInputBox = true;
  detalleCentro: any = {}
  public centro: any;
  public path: any;
  public documentos: any
  public documentoSeleccionado1: any
  public documentoSeleccionado2: any
  public documentoSeleccionado3: any
  public documentoSeleccionado4: any
  public documentoSeleccionado5: any
  public documentoSeleccionado6: any
  public documentosActivos: any
  public documentosVista: any
  public documentosAdicVista: any
  public documentosFirstAdicVista: any
  userLog: any
  role: any
  gestorSeleccionado: any = []
  transportistaSeleccionado: any = []
  allGestores: any = []
  allTransportistas: any = []
  selected: any = []
  selectedTransp: any = []
  idCliente: any
  gestoresObject: any = []
  transporObject: any = []
  docAdicional: any = []
  docAdicional1: any = []
  docAdicional2: any = []
  docAdicional3: any = []
  docAdicional1vista: any = []
  docAdicional2vista: any = []
  docAdicional3vista: any = []

  

  constructor(@Inject(MAT_DIALOG_DATA) public info: {
    id: string,
    refresh: any
  }, private formBuilder: FormBuilder, private apollo: Apollo,
    private centroService: CentroService,
    private router: Router,
    private detalleService: DetalleService,
    private documentoService: DocumentoService,
    private loginService: LoginService,
    private contratistaService: ContratistaService,
    private clienteService: ClienteService,
    private docAdicionalService: DocAdicionalService) {
    this.path = this.router.url;
    this.userLog = this.loginService.getUserData();
    this.role = this.userLog.rol
  }

  ngOnInit(): void {
    if (this.userLog.contratista?.id) {
      this.getGestoresByContratista()
      this.getTransportistasByContratista()
    }
    this.getDocumentosAdicionalByCentro()
    this.getCentroById();
    this.buildForm();
    this.getDocumentosByCentro()

    this.gestorSeleccionado = this.selected;
    this.transportistaSeleccionado = this.selectedTransp
    this.idCliente = this.clienteService.getIdCliente()

  }

  private buildForm() {
    this.detalleCentro = this.formBuilder.group({
      nombre: [''],
      nima: [''],
      direccion: this.formBuilder.group({
        via: [''],
        nombre: [''],
        numero: [''],
        provincia: [''],
        ccaa: [''],
        cp: ['']
      }),
      contacto: this.formBuilder.group({
        contactoNombre: [''],
        contactoMail: [''],
      })
    });
  }

  getCentroById(): void {
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentroById(),
      variables: {
        "id": this.info.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.centro = data.centro
        data.centro.gestors.forEach((gestor: any) => {
          this.selected.push(gestor.id)
          this.gestoresObject.push(gestor)
        });
        data.centro.transportistas.forEach((transportista: any) => {
          this.selectedTransp.push(transportista.id)
          this.transporObject.push(transportista)
        });

        this.displayCentro()
      })
  }

  displayCentro() {
    if (this.detalleCentro) {
      this.detalleCentro.reset()
    }
    console.log(this.centro)
    this.detalleCentro.patchValue({
      nombre: this.centro.nombre,
      nima: this.centro.nima,
      direccion: {
        via: this.centro.direccion?.tipoVia,
        nombre: this.centro.direccion?.nombre,
        numero: this.centro.direccion?.numero,
        provincia: this.centro.direccion?.provincia,
        ccaa: this.centro.direccion?.ccaa,
        cp: this.centro.direccion?.codigoPostal
      },
      contacto: {
        contactoNombre: this.centro.contactoResponsable?.nombre,
        contactoMail: this.centro.contactoResponsable?.mail,
      },
    })
  }

  setCentro() {
    this.centro = { ...this.centro, ...this.detalleCentro.value }
  }

  selectGestores(e: any) {

    const gestor = e.value;
    if (e.selected) {
      this.gestorSeleccionado = [...this.selected, gestor]
      console.log(this.gestorSeleccionado)
    } else {
      this.gestorSeleccionado = this.gestorSeleccionado.filter((i: any) => i !== gestor)
    }
  }

  selectTransportistas(e: any) {

    const transportista = e.value;
    if (e.selected) {
      this.transportistaSeleccionado = [...this.selectedTransp, transportista]
      console.log(this.transportistaSeleccionado)
    } else {
      this.transportistaSeleccionado = this.transportistaSeleccionado.filter((i: any) => i !== transportista)
    }
  }


  getGestoresByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getGestoresByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.allGestores = data.contratista.gestores


      }
      )
  }

  getTransportistasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getTransportistasByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {

        this.allTransportistas = data.contratista.transportistas

      }
      )
  }

  checkEstado() {
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentroById(),
      variables: {
        "id": this.info.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {

        const gestores = data.centro.gestors
        const transportistas = data.centro.transportistas
        const allCondicion = [...gestores, ...transportistas]
        
    
        const filtroRojo = allCondicion.filter((element: any) => element.estado == 'rojo')
        if (filtroRojo.length > 0) {
          this.updateCentroEstado('rojo')
          return
        } else {
          const filtroAmarillo = allCondicion.filter((element: any) => element.estado != 'rojo' && element.estado == 'amarillo' && element.estado != 'verde')
        if (filtroAmarillo.length > 0) {
            this.updateCentroEstado('amarillo')
            return
          } else {

            const filtroVerde = allCondicion.filter((element: any) => element.estado != 'rojo' && element.estado != 'amarillo' && element.estado == 'verde')
        if (filtroVerde.length > 0) {
            this.updateCentroEstado('verde')
            return
            }
          }
        }


      })


  }


  UpdateCentroById() {
    this.setCentro()
    this.apollo.mutate({
      mutation: this.centroService.updateCentro(),
      variables: {
        "input": {
          "where": {
            "id": this.info.id
          },
          "data": {
            "nombre": this.centro.nombre,
            "nima": this.centro.nima,
            "direccion": {
              "tipoVia": this.centro.direccion.via,
              "nombre": this.centro.direccion.nombre,
              "numero": this.centro.direccion.numero,
              "provincia": this.centro.direccion.provincia,
              "ccaa": this.centro.direccion.ccaa,
              "codigoPostal": this.centro.direccion.cp,
            },
            "contactoResponsable": {
              "nombre": this.centro.contacto.contactoNombre,
              "mail": this.centro.contacto.contactoMail
            },
            "gestors": this.gestorSeleccionado,
            "transportistas": this.transportistaSeleccionado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
        this.updateClienteById()
        setTimeout(() => {
          this.checkEstado()
             location.reload()
        }, 2000);

      }, (error) => {
        console.log('Error al lanzar la query', error)
      })
  }

  updateCentroEstado(estado: any) {
    this.apollo.mutate({
      mutation: this.centroService.updateCentro(),
      variables: {
        "input": {
          "where": {
            "id": this.info.id
          },
          "data": {

            "estado": estado,

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('Error al lanzar la query', error)
      })
  }

  updateClienteById() {
    /* console.log(this.idCliente) */
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.idCliente
          },
          "data": {

            "transportistas": this.transportistaSeleccionado,
            "gestores": this.gestorSeleccionado

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  disableInput(): void {
    this.disableInputBox = !this.disableInputBox;
  }

  getDocumentosByCentro(): void {
    this.apollo.watchQuery<any>({
      query: this.documentoService.getDocumentosByCentro(),
      variables: {
        id: this.info.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {

        this.documentos = data.centro.documentos;
        this.documentoSeleccionado1 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'residuosPeligrosos')
        this.documentoSeleccionado2 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'residuosNoPeligrosos')
        this.documentoSeleccionado3 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'informeResiduos')
        this.documentoSeleccionado4 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'contratoTratamiento1')
        this.documentoSeleccionado5 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'contratoTratamiento2')
        this.documentoSeleccionado6 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'contratoTratamiento3')
        this.documentosActivos = this.documentos.filter((documento: any) => documento.tipo != 'inactivo')
        this.documentosVista = this.documentosActivos.filter((documento: any) => documento.tipo != 'pendiente' || !documento.idPadre)
        this.setIndicadores()
      })
  }

  getDocumentosAdicionalByCentro(): void {
    this.apollo.watchQuery<any>({
      query: this.docAdicionalService.getDocumentosByCentro(),
      variables: {
        id: this.info.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data);
        
        this.docAdicional = data.centro.documentos_adicionals
        const docActivos = this.docAdicional.filter((documento: any) => documento.tipo != 'inactivo')
        this.documentosAdicVista = docActivos.filter((documento: any) => documento.tipo != 'pendiente' || !documento.idPadre)
        let hash:any = {};
        this.documentosAdicVista = this.documentosAdicVista.filter((doc:any) => hash[doc.nombreArchivo] ? false : hash[doc.nombreArchivo] = true);
        
        this.docAdicional1=  this.docAdicional.filter((documento:any) => documento.numArchivo === 1 && documento.tipo === null)
        this.docAdicional2=  this.docAdicional.filter((documento:any) => documento.numArchivo === 2 && documento.tipo === null)
        this.docAdicional3=  this.docAdicional.filter((documento:any) => documento.numArchivo === 3 && documento.tipo === null)
        this.docAdicional1vista=  this.documentosAdicVista.filter((documento:any) => documento.numArchivo === 1 && documento.tipo != null)
        this.docAdicional2vista=  this.documentosAdicVista.filter((documento:any) => documento.numArchivo === 2 && documento.tipo != null)
        this.docAdicional3vista=  this.documentosAdicVista.filter((documento:any) => documento.numArchivo === 3 && documento.tipo != null)
        
        console.log('docactivos adic', this.docAdicional1, this.docAdicional2, this.docAdicional3);
        console.log('docactivos adic', this.docAdicional1vista, this.docAdicional2vista, this.docAdicional3vista);

        this.setIndicadoresAdic()
      })
  }

  setIndicadores() {
    this.documentos.map((documento: any) => {
      if (documento?.validado === true) {
        this.setDocumentoProximoCaduca()
        this.setDocumentoCaducado()
        this.setDocumentoEnFecha()
      }
    })
  }

  setDocumentoProximoCaduca() {
    this.documentos.map((documento: any) => {
      if (documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaduca(documento?.id)
      }
    })
  }



  updateDocumentoToProximoCaduca(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false,
            "estado": "amarillo",
            "fechaCheck": this.documentoService.getActualDate()

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  setDocumentoCaducado() {
    this.documentos.map((documento: any) => {
      if (documento.fechaCaducidad <= this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducado(documento.id)
      }
    })
  }

  updateDocumentoToCaducado(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha": false,
            "estado": "rojo",
            "fechaCheck": this.documentoService.getActualDate()

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log(error)
      })
  }

  setDocumentoEnFecha() {
    this.documentos.map((documento: any) => {
      if (documento?.fechaCaducidad > this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento?.id)
      } else if (documento.noCaduca && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento?.id)
      }
    })
  }

  updateDocumentoToEnFecha(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha": true,
            "estado": "verde",
            "fechaCheck": this.documentoService.getActualDate()

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  setIndicadoresAdic() {
    this.docAdicional.map((documento: any) => {
      if (documento?.validado === true) {
        this.setDocumentoProximoCaducaAdic()
        this.setDocumentoCaducadoAdic()
        this.setDocumentoEnFechaAdic()
      }
    })
  }

  setDocumentoProximoCaducaAdic() {
    this.docAdicional.map((documento: any) => {
      if (documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaducaAdic(documento?.id)
      }
    })
  }



  updateDocumentoToProximoCaducaAdic(id: string) {
    this.apollo.mutate({
      mutation: this.docAdicionalService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false,
            "estado": "amarillo"
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  setDocumentoCaducadoAdic() {
    this.docAdicional.map((documento: any) => {
      if (documento.fechaCaducidad <= this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducadoAdic(documento.id)
      }
    })
  }

  updateDocumentoToCaducadoAdic(id: string) {
    this.apollo.mutate({
      mutation: this.docAdicionalService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha": false,
            "estado": "rojo",
            "fechaCheck": this.documentoService.getActualDate()

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log(error)
      })
  }

  setDocumentoEnFechaAdic() {
    this.docAdicional.map((documento: any) => {
      if (documento?.fechaCaducidad > this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFechaAdic(documento?.id)
      } else if (documento.noCaduca && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFechaAdic(documento?.id)
      }
    })
  }

  updateDocumentoToEnFechaAdic(id: string) {
    this.apollo.mutate({
      mutation: this.docAdicionalService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha": true,
            "estado": "verde",
            "fechaCheck": this.documentoService.getActualDate()

          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }
  openDetails(id: string, e: any) {
    const options = {
      id: id,
      nAuth: e.target.id,
    }
    this.detalleService.openTest(options, DocumentosCentroComponent);
  }

  openDetailsDocAdic(id: string, periodo: any, doc:any) {
  
    
    const options = {
      id: id,
      nAuth: doc,
      periocidad:periodo.target.id

    }
    this.detalleService.openTest(options, DocumentosAdicCentroComponent);
  }

  openDocumento(id: string) {
    console.log(id);
    
    const options = {
      id: id,
    }
    this.detalleService.openTest(options, DocDetalleCentroComponent);
  }

  openDocumentoAdic(id: string) {
    console.log(id);
    
    const options = {
      id: id,
    }
    this.detalleService.openTest(options, DocAdicDetalleCentroComponent);
  }
}
